<template>
    <div class="mainRight pageContainer flexCloumn recommendPage">
        <el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
            <div class=""></div>
            <div class="flexEnd flex_1">
                <el-date-picker v-model="searchForm.sxYear" value-format="yyyy-MM-dd" size="small" type="year"
                    placeholder="选择实习年份" style="width:150px;margin-left: 10px"></el-date-picker>
                <el-button icon="el-icon-search" style="margin-left:10px" size="small" type="primary"
                    @click="getList()">搜索</el-button>
            </div>
        </el-row>
        <el-row v-if="!tableData || tableData.length == 0" class="flexCenter" style="width:100%;padding:40px 15px;">
            <div style="text-align: center; color:#909399">
                <div>暂无实习学生~</div>
            </div>
        </el-row>

        <div class="flex_1" style="width:100%;overflow-y:auto;padding:0 15px">
            <ul class="list-items">


                <li class="list-item flexCenter" v-for="(p, idx) in tableData" :key="idx">

                    <div class="list-item-meta flexStart flex_1">
                        <div class="list-item-meta-avatar">
                            <span class="avatar-image flexCenter">
                                <el-image fit="cover" style="width:100%;height:100%;"
                                    :src="p.photo ? p.photo : url"></el-image>
                            </span>
                            <div class="avatarBadgeContainer flexCenter">
                                <img v-if="p.sex == 1" style="width:100%;height:100%;" src="../../../public/img/male.png"
                                    alt="">
                                <img v-if="p.sex == 2" style="width:100%;height:100%;" src="../../../public/img/female.png"
                                    alt="">
                            </div>

                        </div>
                        <div class="list-item-meta-content">
                            <h4 class="list-item-meta-title">
                                <a class="felxStart" href="javascript:;">{{ p.stu_name }}
                                    <span v-if="p.job_arr && p.job_arr.length > 0" v-for="(job, idx_job) in p.job_arr"
                                        style="margin: 0 8px; font-size: 14px;">
                                        {{ job.job_type_name }}</span>
                                </a>
                            </h4>
                            <div class="list-item-meta-description">
                                <div class="flexStart">
                                    <span>岗位:{{ p.job }}</span>
                                    <el-divider direction="vertical" />
                                    <span>薪资:{{ p.salary == 0 ? '面议' : (xzfw[p.salary] || "-") }}</span>
                                    <el-divider direction="vertical" />
                                    <span>电话:{{ p.phone || '-' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul class="list-item-action felxCloumn">
                        <li>
                            <div class="flexCenter">
                                <el-tag size="mini" @click.stop="view(p, 1)" type="primary"
                                    style="cursor:pointer;">实习申请</el-tag>
                                <el-tag class="ml10" size="mini" @click.stop="view(p, 2)" type="primary"
                                    style="cursor:pointer;" plain>打卡记录</el-tag>
                                <el-tag class="ml10" size="mini" @click.stop="view(p, 3)" type="primary"
                                    style="cursor:pointer;" plain>周报</el-tag>
                                <el-tag class="ml10" size="mini" @click.stop="view(p, 4)" type="primary"
                                    style="cursor:pointer;" plain>月报</el-tag>
                            </div>
                        </li>

                    </ul>
                </li>
            </ul>
        </div>
        <el-pagination :current-page="page.current_page" :total="page.count" layout="total,prev, pager, next"
            style="margin: 10px 0 0 15px;">
        </el-pagination>

        <!-- 实习申请 -->
        <el-dialog ref="ruleForm" :visible.sync="dialogForm_1" :close-on-click-modal="false" custom-class="cus_dialog"
            width="1000px">
            <div slot="title" class="flexBetween">
                <span style="color: #ffffff;">{{ stuInfo.stu_name }}实习申请</span>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="'实习详情' + (applyList.length - idx) + '(' + item.check_txt + '-' + item.sx_status + ')'"
                    :name="'tab' + item.id" v-for="(item, idx) in applyList" :key="idx">

                </el-tab-pane>
                <el-tab-pane v-if="formData && formData.sxbg && formData.sxbg.length > 0" label="实习变更" name="second">
                    <el-table :data="formData.sxbg" row-key="id" border stripe>
                        <el-table-column label="变更时间" prop="cdate" width="170" align="center">
                            <template slot-scope="scope">{{ scope.row.cdate }}</template>
                        </el-table-column>
                        <el-table-column label="变更后企业名称" prop="firm_name" min-width="140px"></el-table-column>
                        <el-table-column label="变更后企业性质" prop="info" width="120px">
                            <template slot-scope="scope">{{ qyxz[scope.row.info - 1].param_desc }}</template>
                        </el-table-column>
                        <el-table-column label="变更后企业负责人" prop="firm_content_name" width="140px"></el-table-column>
                        <el-table-column label="变更后负责人电话" prop="firm_content_tel" width="140px"></el-table-column>
                        <el-table-column label="变更审批状态" prop="check_status" width="120px" align="center">
                            <template slot-scope="scope">
                                <el-tag size="mini" v-if="scope.row.check_status == -1">待完善</el-tag>
                                <el-tag size="mini" v-if="scope.row.check_status == 0" style="color:orange">待审核</el-tag>
                                <el-tag size="mini" v-if="scope.row.check_status == 1" style="color:green">审核通过</el-tag>
                                <el-tag size="mini" v-if="scope.row.check_status == 2" style="color:red">审核拒绝</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

                <div class="dialog_right" v-if="activeName != 'second'">
                    <div v-if="formData.check_reason" class="flexStart"
                        style="flex-wrap: wrap;width: 100%;margin-top: 10px;border-right: 1px solid #d9e4f6;border-bottom: 1px solid #d9e4f6;">
                        <div class="lineRow flexStretch" style="width:100%;">
                            <div class="cell flexStart" style="min-height: 40px;height: unset;">审批原因</div>
                            <div class="cell flexCloumn flex_1"
                                style="height: unset;justify-content: center;min-height: 40px;color:orangered">
                                {{ formData.check_reason }}
                            </div>
                        </div>
                    </div>
                    <div v-if="formData.revoke_reason" class="flexStart"
                        style="flex-wrap: wrap;width: 100%;margin-top: 10px;border-right: 1px solid #d9e4f6;border-bottom: 1px solid #d9e4f6;">
                        <div class="lineRow flexStretch" style="width:100%;">
                            <div class="cell flexStart" style="min-height: 40px;height: unset;">撤回原因</div>
                            <div class="cell flexCloumn flex_1"
                                style="height: unset;justify-content: center;min-height: 40px;color:orangered">
                                {{ formData.revoke_reason }}
                            </div>
                        </div>
                    </div>
                    <div class="cellGroupBarTitle flexStart" style="margin-top:10px;">
                        <span></span>
                        <span style="font-weight: 400">学生信息</span>
                    </div>

                    <div class="flexStart"
                        style="flex-wrap: wrap;width: 100%;margin-top: 10px;border-right: 1px solid #d9e4f6;border-bottom: 1px solid #d9e4f6;">
                        <div class="lineRow flexStretch" style="width:33.3%;">
                            <div class="cell flexStart">姓名</div>
                            <div class="cell flexStart flex_1">{{ formData.stu_name }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:33.3%;">
                            <div class="cell flexStart">班级</div>
                            <div class="cell flexStart flex_1">{{ formData.class_name }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:33.3%;">
                            <div class="cell flexStart">实习去向</div>
                            <div class="cell flexStart flex_1">{{ sxqxObj[formData.sxqx] }}</div>
                        </div>

                    </div>
                    <div v-if="formData.sxqx == 1 || formData.sxqx == 7" class="cellGroupBarTitle flexStart"
                        style="margin-top:10px;">
                        <span></span>
                        <span style="font-weight: 400">企业信息</span>
                    </div>
                    <div v-if="formData.sxqx == 1 || formData.sxqx == 7" class="flexStart"
                        style="flex-wrap: wrap;width: 100%;margin-top: 10px;border-right: 1px solid #d9e4f6;border-bottom: 1px solid #d9e4f6;">
                        <div class="lineRow flexStretch" style="width:100%;">
                            <div class="cell flexStart">企业名称</div>
                            <div class="cell flexStart flex_1">{{ formData.firm_name }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">社会统一<br />信用代码</div>
                            <div class="cell flexStart flex_1">{{ formData.firm_num }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">企业性质</div>
                            <div class="cell flexStart flex_1">{{ qyxzObj[formData.info] || '-' }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">企业部门</div>
                            <div class="cell flexStart flex_1">{{ formData.department }}</div>
                        </div>

                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">实习岗位</div>
                            <div class="cell flexStart flex_1">{{ formData.job }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">企业联系人</div>
                            <div class="cell flexStart flex_1">{{ formData.firm_content_name }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">联系人电话</div>
                            <div class="cell flexStart flex_1">{{ formData.firm_content_tel }}</div>
                        </div>

                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">指导老师</div>
                            <div class="cell flexStart flex_1">{{ formData.mentor_name }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">指导老师电话</div>
                            <div class="cell flexStart flex_1">{{ formData.mentor_tel }}</div>
                        </div>


                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">实习薪资</div>
                            <div class="cell flexStart flex_1">{{ formData.xinzi }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">薪资范围</div>
                            <div class="cell flexStart flex_1">{{ salaryObj[formData.salary] }}</div>
                        </div>

                        <div class="lineRow flexStretch" style="width:100%;">
                            <div class="cell flexStart">实际上班地址</div>
                            <div class="cell flexStart flex_1">{{ formData.address }}</div>
                        </div>

                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">安排方式</div>
                            <div class="cell flexStart flex_1">{{ anpaiObj[formData.anpai_type] }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">专业对口情况</div>
                            <div class="cell flexStart flex_1">{{ formData.is_ok == 1 ? '对口' : (formData.is_ok == 0 ? '不对口'
                                : '-') }}
                            </div>
                        </div>

                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">有无劳动合同</div>
                            <div class="cell flexStart flex_1">{{ formData.is_contract == 1 ? '有' : (formData.is_contract ==
                                0 ? '没有'
                                : '-') }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">是否购买保险</div>
                            <div class="cell flexStart flex_1">{{ formData.insured == 1 ? '有' : (formData.insured == 0 ?
                                '没有' : '-')
                            }}</div>
                        </div>

                        <div class="lineRow flexStretch" style="width:100%;">
                            <div class="cell flexStart">有无公积金</div>
                            <div class="cell flexStart flex_1">{{ formData.is_housing_fund == 1 ? '有' :
                                (formData.is_housing_fund == 0
                                    ? '没有' : '-') }}</div>
                        </div>

                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">实习开始时间</div>
                            <div class="cell flexStart flex_1">{{ formData.start_time }}</div>
                        </div>
                        <div class="lineRow flexStretch" style="width:50%;">
                            <div class="cell flexStart">实习结束时间</div>
                            <div class="cell flexStart flex_1">{{ formData.end_time }}</div>
                        </div>
                    </div>
                    <div class="cellGroupBarTitle flexStart" style="margin-top:10px;">
                        <span></span>
                        <span style="font-weight: 400">资料附件</span>
                    </div>
                    <div class="flexStart"
                        style="flex-wrap: wrap;width: 100%;margin-top: 10px;border-right: 1px solid #d9e4f6;border-bottom: 1px solid #d9e4f6;">
                        <div class="lineRow flexStretch" style="width:100%;">
                            <div class="cell flexStart" style="min-height: 40px;height: unset;">协议/资料</div>
                            <div class="cell flexStart flex_1"
                                style="height: unset;min-height: 40px;flex-wrap:wrap;padding-top:8px;">
                                <div class="flexCenter" v-for="(f, idx) in formData.cover"
                                    style="position:relative;height:100px;width:100px;border:1px dashed #c0ccda;border-radius:6px;margin-right:8px;margin-bottom:8px;">
                                    <el-image style="max-height:100%;max-width:100%;" :src="f.fileUrl"
                                        :preview-src-list="formData.cover.map(e => { return e.fileUrl })" img="cover"
                                        :z-index="3000"></el-image>
                                </div>
                                <div v-if="!formData.cover || formData.cover == 0" class="" style="width:100%;">-</div>
                            </div>
                        </div>
                    </div>

                    <div style="height:100px;"></div>



                </div>
                <el-tab-pane v-if="formData && formData.sxbg && formData.sxbg.length > 0" label="实习变更" name="second">
                    <el-table :data="formData.sxbg" row-key="id" border stripe>
                        <el-table-column label="变更时间" prop="cdate" width="170" align="center">
                            <template slot-scope="scope">{{ scope.row.cdate }}</template>
                        </el-table-column>
                        <el-table-column label="变更后企业名称" prop="firm_name" min-width="140px"></el-table-column>
                        <el-table-column label="变更后企业性质" prop="info" width="120px">
                            <template slot-scope="scope">{{ qyxz[scope.row.info - 1].param_desc }}</template>
                        </el-table-column>
                        <el-table-column label="变更后企业负责人" prop="firm_content_name" width="140px"></el-table-column>
                        <el-table-column label="变更后负责人电话" prop="firm_content_tel" width="140px"></el-table-column>
                        <el-table-column label="变更审批状态" prop="check_status" width="120px" align="center">
                            <template slot-scope="scope">
                                <el-tag size="mini" v-if="scope.row.check_status == -1">待完善</el-tag>
                                <el-tag size="mini" v-if="scope.row.check_status == 0" style="color:orange">待审核</el-tag>
                                <el-tag size="mini" v-if="scope.row.check_status == 1" style="color:green">审核通过</el-tag>
                                <el-tag size="mini" v-if="scope.row.check_status == 2" style="color:red">审核拒绝</el-tag>
                                <el-tag size="mini" v-if="scope.row.check_status == 3" style="color:red">撤回</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <!-- 打卡 -->
        <el-dialog class="cus_dialog" :visible.sync="dialogShow" :close-on-click-modal="false" custom-class="cus_dialog"
            width="1000px">
            <div slot="title" class="flexBetween">
                <span style="color: #ffffff;">{{ stuInfo.stu_name }}打卡详情</span>
            </div>
            <div style="width:100%;height:10px;"></div>
            请选择打卡月份：
            <el-date-picker size="small" style="width:150px;margin-right:10px" v-model="detailMonth" value-format="yyyy-MM"
                type="month" placeholder="选择月" @change="reloadLog"></el-date-picker>

            <el-table :data="signLogs" row-key="id" border stripe style="margin-top:10px;">
                <el-table-column type="index" label="序号" width="60px"></el-table-column>
                <el-table-column label="姓名" prop="stu_name" width="100px"></el-table-column>
                <el-table-column label="所在班级" prop="class_name" show-overflow-tooltip width="150px"></el-table-column>
                <el-table-column label="系部" prop="class_name" show-overflow-tooltip min-width="150px">
                    <template slot-scope="scope">{{ scope.row.yx_name }} {{ scope.row.major_name }}</template>
                </el-table-column>
                <el-table-column label="打卡时间" prop="sign_time" width="200px">

                </el-table-column>
                <el-table-column label="打卡类型" prop="remark" width="150px">
                    <template slot-scope="scope">{{ scope.row.remark ? scope.row.remark : '正常打卡' }}</template>
                </el-table-column>

                <el-table-column label="详细地址" prop="remark" show-overflow-tooltip min-width="200px">
                    <template slot-scope="scope">{{ scope.row.sign_address }}</template>
                </el-table-column>

                <el-table-column label="打卡图片" prop="dk_status" width="120px">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.pic" style="width: 100px;height:40px;" :src="scope.row.pic"
                            :preview-src-list="[scope.row.pic]" fit="contain" :z-index="3000" />
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!--周月报 -->
        <el-dialog class="cus_dialog" :visible.sync="dialogForm_2" :close-on-click-modal="false" custom-class="cus_dialog"
            width="1000px">
            <div slot="title" class="flexBetween">
                <span style="color: #ffffff;">{{ stuInfo.stu_name }}{{ report_type == 0 ? '周' : '月' }}报列表</span>
            </div>
            <el-table :data="reportList" height="100%" size="small" stripe border style="width:fit-content;width:100%;"
                tooltip-effect="dark myTooltips">
                <el-table-column type="index" width="65" label="序号" align="center"></el-table-column>
                <el-table-column prop="sp_status" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.report_status == 2" type="warning">审核撤回</el-tag>
                        <el-tag size="mini" v-if="scope.row.report_status == -1" type="danger">审核拒绝</el-tag>
                        <el-tag size="mini" v-if="scope.row.report_status == 1" type="success">审核通过</el-tag>
                        <el-tag size="mini" v-if="scope.row.report_status == 0 && !scope.row.review_comment"
                            style="color: gray;">待审核</el-tag>
                        <el-tag size="mini" v-if="scope.row.report_status == 0 && scope.row.review_comment"
                            style="color: goldenrod;">重新提交</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="stu_code" label="学号" width="135" align="center"></el-table-column>
                <el-table-column prop="stu_name" label="学生姓名" width="120" align="center"></el-table-column>


                <el-table-column v-if="report_type == 0" prop="create_date" label="周次" width="135" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sp_chaoshi">
                            <el-tooltip :content="('超时审批，应该在' + scope.row.last_date + '之前审批')" placement="top">
                                <span style="color:#f56c6c;">{{ scope.row.report_year }}年第{{ scope.row.number }}周</span>
                            </el-tooltip>
                        </div>
                        <div v-else>{{ scope.row.report_year }}年第{{ scope.row.number }}周</div>
                    </template>
                </el-table-column>
                <el-table-column v-if="report_type == 1" prop="create_date" label="月份" width="135" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sp_chaoshi">
                            <el-tooltip :content="('超时审批，应该在' + scope.row.last_date + '之前审批')" placement="top">
                                <span style="color:#f56c6c;">{{ scope.row.report_year }}年{{ scope.row.report_month
                                }}月</span>
                            </el-tooltip>
                        </div>
                        <div v-else>{{ scope.row.report_year }}年{{ scope.row.report_month }}月</div>
                    </template>
                </el-table-column>
                <el-table-column label="提交日期" prop="create_date" width="200" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.udate || scope.row.create_date }}
                    </template>
                </el-table-column>
                <el-table-column prop="is_replenish" label="是否补报" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_replenish == 1" style="color: blue;">是</div>
                        <div v-else>否</div>
                    </template>
                </el-table-column>
                <el-table-column prop="review_name" label="审批人" width="100" align="center" />
                <el-table-column prop="score" label="评分" width="80" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.score > 0">{{ getScoreTxt(scope.row.score) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="review_comment" label="审批评语" width="260" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column prop="review_time" label="审批时间" width="200" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sp_chaoshi">
                            <el-tooltip :content="('超时审批，应该在' + scope.row.last_date + '之前审批')" placement="top">
                                <span style="color:#f56c6c;">{{ scope.row.review_time }}</span>
                            </el-tooltip>
                        </div>
                        <div v-else>{{ scope.row.review_time }}</div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag type="" size="mini" @click="viewInfo(scope.row)" style="cursor:pointer;">详情</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>



        <!-- 报告详情 -->
        <el-dialog :visible.sync="dialogshow_detail" :close-on-click-modal="false" :modal-append-to-body="false"
            :destroy-on-close="true" custom-class="cus_dialog" width="800px">
            <div slot="title" class="flexBetween">
                <span style="color: #ffffff;">{{ EditItem.report_name }}</span>
            </div>
            <div>
                <div class="cellGroupBarTitle flexStart" style="margin-top:10px;">
                    <span></span>
                    <span style="font-weight: 400">报告内容</span>
                </div>
                <el-form :model="EditItem" ref="EditItem" label-width="90px" label-position="left">
                    <el-row style="padding-top: 10px;">
                        <el-col :span="12">
                            <el-form-item label="学生姓名">
                                <el-input v-model="EditItem.stu_name" readonly style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="班级">
                                <el-input v-model="EditItem.class_name" readonly style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row style="padding-top: 0px;">
                        <el-col :span="12">
                            <el-form-item label="提交日期">
                                <el-input :value="EditItem.create_date" readonly style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否补交">
                                <el-input readonly :value="EditItem.is_replenish == 1 ? '是' : '否'"
                                    style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row style="padding-top: 0px;" v-for="(item, idx) in EditItem.report_info" :key="idx">
                        <el-col :span="22">
                            <el-form-item :label="item.name" v-if="item.type == 'textarea'">

                                <div class="textarea_indent" v-html="item.real_values_html || item.real_values || '-'">

                                </div>
                            </el-form-item>
                            <el-form-item :label="item.name" v-if="item.type == 'text' || item.type == 'radio'">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" readonly
                                    :value="item.real_values"></el-input>
                            </el-form-item>
                            <el-form-item :label="item.name" v-if="item.type == 'checkbox'">
                                <el-input v-if="item.real_values" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }"
                                    readonly :value="item.real_values.join(',')"></el-input>
                            </el-form-item>
                            <el-form-item :label="item.name" v-if="item.type == 'file'">
                                <div style="width:100%">
                                    <div style="display:inline-block; margin-right:10px;vertical-align: top; position: relative;"
                                        v-for="(img, i) in item.real_values" :key="i" v-if="img.type != 'file'">
                                        <el-image style="width: 100px; height: 100px" :src="img.fileUrl || img.src"
                                            :preview-src-list="item.real_values.map(e => { return e.fileUrl || e.src })"
                                            img="cover" :z-index="3000"></el-image>


                                    </div>

                                    <div style="line-height: normal;">
                                        <!-- <el-divider content-position="left">其他附件</el-divider> -->
                                        <p v-for="(file, i) in item.real_values" :key="i" v-if="file.type == 'file'">

                                            <el-link type="primary" icon="el-icon-download" :href="file.fileUrl">{{
                                                file.fileName }}</el-link>
                                        </p>
                                        <div class="" v-if="!item.real_values || item.real_values.length == 0"
                                            style="line-height:40px;">-
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class=""
                        v-if="EditItem.report_status == 1 || EditItem.report_status == -1 || EditItem.report_status == 2">
                        <div class="cellGroupBarTitle flexStart" style="margin-top:10px;">
                            <span></span>
                            <span style="font-weight: 400">审批结果</span>
                        </div>
                        <el-form-item label="审批结果" style="padding-top:10px;">
                            <div>
                                <el-tag type="success" v-if="EditItem.report_status == 1" size="small">审批通过</el-tag>
                                <el-tag type="danger" v-if="EditItem.report_status == -1" size="small">审批拒绝</el-tag>
                                <el-tag type="warning" v-if="EditItem.report_status == 2" size="small">审批撤回</el-tag>
                            </div>
                        </el-form-item>
                        <el-form-item label="评分">
                            <div style="display:inline-block">
                                <el-rate readonly disabled v-model="EditItem.score" show-text
                                    :texts="['差', '中', '中', '良', '优']"></el-rate>
                            </div>
                        </el-form-item>
                        <el-form-item label="评语">
                            <div>
                                <span style="">{{ EditItem.review_comment || '-' }}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="撤回原因" v-if="EditItem.report_status == 2">
                            <el-col :span="22">
                                <div>
                                    <span style="">{{ EditItem.revoke_reason || '-' }}</span>
                                </div>
                            </el-col>
                        </el-form-item>
                    </div>
                </el-form>
                <div style="height:50px"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import citys from "../../utils/arae_value.js";
import Detail from "./com/resumeDetail.vue";
import util from "../../utils/util.js";
import aes from '../../utils/aes.js'

export default {
    components: {
        Detail
    },
    data() {
        return {
            dialogForm: false,
            formData: {},
            job_type: [],
            job_id: "",
            page: {
                count: 0,
                current_page: 1,
                per_page: 20,
                total_page: 0
            },
            jobOptions: [],
            tableData: [],
            jobHtml: "",
            practiceHtml: "",
            projectHtml: "",
            tdzt: {},
            mszt: {},
            lyzt: {},
            xlyq: {},
            xzfw: {},
            qzzt: {},
            yqzt: {},
            options: [],
            url: "./img/img_avatar.png",
            srcList: [
                "./img/img_avatar.png"
            ],
            searchForm: {
                sxYear: util.formatDate(new Date())
            },
            firmId: '',
            stuInfo: {},
            // 实习申请
            dialogForm_1: false,
            applyList: [],
            sxqxArr: [], sxqxObj: {},
            qyxz: [], qyxzObj: {},
            salary: [], salaryObj: {},
            activeName: "first",
            anpaiObj: {
                0: '学校安排', 1: '自主选择', 2: '定向培养'
            },
            // 打卡
            dialogShow: false,
            detailMonth: this.$moment().format("YYYY-MM"),
            signLogs: [],
            // 周月报
            dialogForm_2: false,
            reportList: [],
            report_type: 0,
            // 报告详情
            dialogshow_detail: false,
            EditItem: {},
            firm_num: ''

        };
    },
    mounted() {
        let _this = this
        this.getComType().then(rr => {

            _this.$http.post("/api/enterprise_info").then(res => {
                _this.firmId = res.data.id;
                _this.firm_num = res.data.firm_num
                _this.getList();
            });
        });

    },
    methods: {
        getComType() {
            return new Promise(resolve => {
                this.$http
                    .post("/api/sys_param_list", {
                        param_type:
                            "'TDZT','LYZT','MSZT','EDUACTION','SALARY_RANGE','QZZT','YQZT','ENTER_INFO','SHIXI_STATUS'",
                        used: 0
                    })
                    .then(res => {
                        let tdzt = {}; //投递状态
                        let mszt = {}; //面试状态
                        let lyzt = {}; //录用状态
                        let xzfw = {}; //薪资类型
                        let xlyq = {}; //学历类型
                        let qzzt = {}; //求职状态
                        let yqzt = {}; //邀请状态
                        let sxqxArr = [], sxqxObj = {};//实习去向
                        let qyxz = [], qyxzObj = {};//企业性质
                        let salary = [], salaryObj = {};//薪资范围

                        for (let item of res.data) {
                            if (item.param_type == "TDZT") {
                                tdzt[item.param_value] = item.param_desc;
                            }
                            if (item.param_type == "SALARY_RANGE") {

                                xzfw[item.param_value] = item.param_desc;
                                salary.push(item);
                                salaryObj[item.param_value] = item.param_desc
                            }
                            if (item.param_type == "EDUACTION") {

                                xlyq[item.param_value] = item.param_desc;
                            }
                            if (item.param_type == "MSZT") {

                                mszt[item.param_value] = item.param_desc;
                            }
                            if (item.param_type == "LYZT") {

                                lyzt[item.param_value] = item.param_desc;
                            }
                            if (item.param_type == "QZZT") {

                                qzzt[item.param_value] = item.param_desc;
                            }
                            if (item.param_type == "YQZT") {

                                yqzt[item.param_value] = item.param_desc;
                            }
                            if (item.param_type == "ENTER_INFO") {
                                qyxz.push(item);
                                qyxzObj[item.param_value] = item.param_desc
                            }
                            if (item.param_type == "SHIXI_STATUS") {
                                sxqxArr.push(item);
                                sxqxObj[item.param_value] = item.param_desc
                            }
                        }
                        this.tdzt = tdzt;
                        this.mszt = mszt;
                        this.lyzt = lyzt;
                        this.xzfw = xzfw;
                        this.xlyq = xlyq;
                        this.qzzt = qzzt;
                        this.yqzt = yqzt;
                        this.sxqxArr = sxqxArr;
                        this.sxqxObj = sxqxObj;
                        this.qyxz = qyxz;
                        this.qyxzObj = qyxzObj;
                        this.salary = salary;
                        this.salaryObj = salaryObj;

                        resolve();
                    });
            });
        },
        getList() {
            const loading = this.$globalLoading()

            let data = {};
            data.job_type = this.job_type.length > 0 ? this.job_type[2] : '';
            data.page = this.page.current_page;
            data.pagesize = this.page.per_page;
            this.$http.post("/api/stu_enter_list", {
                firm_num: this.firm_num,
                sxYear: this.searchForm.sxYear
            }).then(res => {
                console.log(1000, res.data)
                if (res.data && res.data.length > 0) {
                    this.tableData = res.data;
                    this.page.count = res.data.length
                    this.$forceUpdate()
                    console.log(1, this.tableData)

                } else {
                    console.log(21, res.data)
                    this.tableData = [];
                    this.page.count = 0

                    this.$forceUpdate()
                }
                loading.close()

            });
        },
        getParentId(list, iid) {
            if (list && list.length > 0) {
                for (let o of list) {
                    if (o.value == iid) return o;
                    const o_ = this.getParentId(o.children, iid);
                    if (o_) return o_;
                }
            }
        },

        canParseToJson(str, parseFlag) {
            try {
                if (typeof JSON.parse(str) === "object" && ((Object.prototype.toString.call(JSON.parse(str)) === "[object Object]") ||
                    (Object.prototype.toString.call(JSON.parse(str)) === "[object Array]"))) {
                    return parseFlag === true ? JSON.parse(str) : true
                }
            } catch (e) { }
            return false
        },
        xiangqing(row) {
            let _this = this
            this.$http.post("/api/zp_resume_info", { id: row.stu_id }).then(res => {
                // this.$http.post("/api/zp_resume_info", { id: 5003 }).then(res => {
                let beforedata = res.data
                let result = res.data
                // beforedata = aes.decrypt(beforedata).then(result => {
                    if (result && _this.isJSON(result)) {
                        let finalData = JSON.parse(result)
                        // console.log(210, finalData)
                        if (finalData) {
                            res.data = finalData

                            if (!res.data.tel) {
                                res.data.tel = '***********'
                            } else {
                                res.data.tel = '***********'
                            }

                            if (!res.data.wechat) {
                                res.data.wechat = '***********'
                            } else {
                                res.data.wechat = '***********'

                            }

                            if (res.data.award_annex && this.canParseToJson(res.data.award_annex)) {
                                res.data.award_annex = JSON.parse(res.data.award_annex)
                            }
                            if (res.data.job_array) {
                                res.data.job_array.map(a => {
                                    let obj = this.getParentId(citys, a.city);
                                    a.cityName = obj ? obj.label : '';
                                });
                            }
                            if (res.data.practice && this.canParseToJson(res.data.practice)) {
                                res.data.practice = JSON.parse(res.data.practice)
                            }
                            if (res.data.project && this.canParseToJson(res.data.project)) {
                                res.data.project = JSON.parse(res.data.project)
                                res.data.project.map(a => {
                                    if (a.annex && this.canParseToJson(a.annex)) {
                                        a.annex = JSON.parse(a.annex)
                                    }
                                })
                            }

                            this.formData = res.data;
                            this.dialogForm = true;

                        }
                    }
                // })
            });
        },
        handleClick(tab, event) {

            for (let item of this.applyList) {
                if ("tab" + item.id == this.activeName) {
                    this.formData = item;
                }
            }
        },
        view(row, type) {
            this.stuInfo = row
            if (type == 1) {



                this.$http.post("/api/t_sch_stu_enter_from_list", { stu_id: row.stu_id }).then(res => {
                    console.log(536, res.data)

                    for (let item of res.data) {
                        item.cover = JSON.parse(item.cover);
                        this.sxqxArr.map(d => {
                            try {
                                if (d.param_value == item.sxqx) {
                                    item.sxqxLabel = d.param_desc;
                                }
                            } catch { }
                        });
                        item.info = String(item.info)
                        item.infoLabel = this.qyxzObj[item.info]
                        if (row.id == item.id) {
                            this.formData = item;
                            this.activeName = "tab" + item.id;
                        }

                        if (item.check_status == -1) {
                            item.check_txt = "待完善"
                        } else if (item.check_status == 0) {
                            item.check_txt = "待审核"
                        } else if (item.check_status == 1) {
                            item.check_txt = "审核通过"
                        } else if (item.check_status == 2) {
                            item.check_txt = "审核拒绝"
                        } else if (item.check_status == 3) {
                            item.check_txt = "撤回"
                        }
                        console.log(561, item)

                    }
                    this.applyList = res.data

                    if (res.data && res.data.length > 0) {
                        this.formData = (res.data && res.data.length > 0) ? res.data[0] : {}
                        this.activeName = "tab" + res.data[0].id;

                    }


                    this.dialogForm_1 = true;
                });



            }
            if (type == 2) {
                this.reloadLog()
            }
            if (type == 3 || type == 4) {

                this.report_type = (type == 3) ? 0 : 1
                this.$http
                    .post("/api/stu_report_approval_list", {
                        stu_id: this.stuInfo.stu_id,
                        report_type: type == 3 ? 0 : 1,
                        page: 1, pagesize: 1000000,
                    })
                    .then(res => {
                        this.reportList = res.data.data;
                        this.dialogForm_2 = true;
                    });
            }
        },
        reloadLog() {
            this.$http
                .post("/api/get_clock_in_log", {
                    stu_id: this.stuInfo.stu_id,
                    sign_start: this.detailMonth + "-01",
                    sign_end: this.$moment(this.detailMonth + "-01").endOf('months').format('YYYY-MM-DD')

                })
                .then(res => {
                    this.signLogs = res.data;
                    this.dialogShow = true;
                });

        },
        getScoreTxt(score) {
            let txt = "";

            switch (score) {
                case 1:
                    txt = "不及格";
                    break;
                case 2:
                    txt = "及格";
                    break;
                case 3:
                    txt = "中等";
                    break;
                case 4:
                    txt = "良好";
                    break;
                case 5:
                    txt = "优秀";
                    break;
            }
            return txt;
        },
        viewInfo(row) {
            this.$http
                .post("/api/report_approval_info_byid", { id: row.id })
                .then(res => {
                    res.data.report_info = JSON.parse(res.data.report_info);
                    console.log(res.data.report_info);
                    this.EditItem = res.data;
                    this.dialogshow_detail = true
                });
        }
    }
};
</script>

<style scoped lang="less">
.pageContainer {
    /deep/ .box-card {
        margin-bottom: 12px;
        padding: 24px 10px 24px 30px;
    }

    /deep/ .el-card__body {
        padding: 0px;
    }

}

.recommendPage {

    ul,
    li {
        list-style: none;

        outline: none;
    }

    .list-items {
        width: 100%;
        margin: 5px 0 0 0;
        padding: 0;
        list-style: none;

        outline: none;

        .list-item {

            background-color: #fff;
            padding: 24px !important;
            border: 0;
            margin-bottom: 12px;
            outline: none;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

            .list-item-meta {
                align-items: center;

                .list-item-meta-avatar {
                    position: relative;
                    margin-right: 16px;

                    span {
                        width: 52px;
                        height: 52px;
                        line-height: 52px;
                        border-radius: 50%;
                        margin: 0;
                        padding: 0;
                        font-size: 14px;
                        font-variant: tabular-nums;
                        list-style: none;
                        font-feature-settings: 'tnum';
                        position: relative;
                        display: inline-block;
                        overflow: hidden;
                        color: #fff;
                        white-space: nowrap;
                        text-align: center;
                        vertical-align: middle;
                    }

                    .avatarBadgeContainer {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 14px;
                        height: 14px;
                        border-radius: 50%;
                        /* border: 1px solid #fff; */
                        overflow: hidden;
                        background-color: #fff;
                    }
                }

                .list-item-meta-content {
                    -webkit-box-flex: 1;
                    flex: 1 0;

                    .list-item-meta-title {
                        font-size: 18px;
                        margin-top: 0;
                        margin-bottom: 17px;
                        color: #000000a6;
                        line-height: 22px;
                        font-weight: 500;

                        a {
                            font-size: 18px;
                            color: #000000a6;
                            -webkit-transition: all 0.3s;
                            transition: all 0.3s;
                            touch-action: manipulation;
                            background-color: transparent;
                            cursor: pointer;
                            text-decoration: none;
                            outline: none;
                        }
                    }

                    .list-item-meta-description {
                        color: rgba(0, 0, 0, 0.45);
                        font-size: 14px;
                        line-height: 22px;

                        span {
                            font-size: 14px;
                            color: rgb(48, 49, 51);
                        }
                    }
                }

            }

            .list-content {
                .list-content-item {
                    color: rgba(0, 0, 0, 0.45);
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 14px;
                    margin-left: 40px;

                    p {
                        margin-top: 4px;
                        margin-bottom: 0;
                        line-height: 22px;
                    }
                }
            }

            .list-item-action {
                flex: 0 0 auto;
                margin-left: 48px;
                padding: 0;
                font-size: 0;
                list-style: none;
            }
        }
    }

    .cus_dialog {

        div {
            box-sizing: border-box;
        }

        .rowContainer {
            width: 100%;

            .item-userinfo {
                margin-top: 32px;

                .color30 {
                    color: #303133;
                }

                .color60 {
                    color: #606266;
                }

                .fontWeight500 {
                    font-weight: 700;
                }

                .left {
                    width: 100px;
                }

                .right {
                    margin-left: 32px;

                    .userName {
                        font-size: 18px;
                        color: #303133;
                        font-weight: 500;
                        margin-right: 4px;
                    }

                    .contact {
                        margin-top: 8px;
                    }

                    .timestamp {
                        color: #909399;
                        font-size: 12px;
                    }

                    .commonText {
                        margin-top: 8px;
                    }

                    .annexResume {
                        margin-top: 8px;
                        color: #3378fa;
                        cursor: pointer;
                    }

                    .item-att {
                        margin-left: 8px;
                        color: #3378fa;
                        cursor: pointer;
                    }
                }
            }

            .item-userinfo:first-of-type {
                margin-top: 0;
            }

            .subitem-userinfo {
                margin-top: 16px;
                color: #606266;
            }

            .crumbImg {
                width: 100%;

                .thumbnail {
                    display: inline-block;
                    width: 20%;

                    img {
                        display: inline-block;
                        width: 100%;
                    }
                }
            }
        }

        .avatarContainer {
            flex: 0 1 68px;

            &>span {
                border-radius: 68px;
                display: block;
                width: 68px;
                height: 68px;
                line-height: 68px;
            }

            .ant-avatar.ant-avatar-icon {
                font-size: 40px;
            }

            img {
                display: inline-block;
                width: 68px;
                height: 68px;
                border-radius: 50%;
            }
        }

        .right {
            .ant-divider-vertical {
                margin: 0 16px;
            }
        }



    }
}

/deep/ .el-dialog__body {
    padding: 0px 21px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

/deep/ .el-tabs__item {
    font-size: 18px;
}

.dialog_right {
    .lineRow {
        .cell:first-of-type {
            width: 120px;
        }

    }
}
</style>
